module.exports = __webpack_public_path__ + "static/media/0018.0ed74cfa.jpg";